import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 sm:px-6 lg:px-8">
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-full sm:max-w-lg lg:max-w-2xl">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0A827D] mb-6 text-center">
          Politique de Confidentialité
        </h1>
        <p className="text-gray-600 leading-relaxed mb-4">
          Chez MOSA Ingénierie, nous respectons votre vie privée. Nous ne
          collectons aucune donnée personnelle à l'exception des informations
          fournies volontairement via notre formulaire de contact, telles que
          votre nom, votre adresse email et le contenu de votre message.
        </p>
        <p className="text-gray-600 leading-relaxed mb-4">
          Ces informations sont utilisées uniquement pour répondre à vos
          demandes de manière efficace. Nous nous engageons à ne pas partager ni
          revendre vos données personnelles à des tiers.
        </p>
        <p className="text-gray-600 leading-relaxed">
          Si vous avez des questions concernant notre politique de
          confidentialité, n'hésitez pas à nous contacter via notre formulaire
          ou à l'adresse email indiquée sur notre site.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
